module.exports = __webpack_public_path__ + "static/media/expiry.7c84ebac.png";